"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.simple-form"));

var _gerenciatdUnifiedcomponents3 = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.input"));

require("./NotFound.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotFound = /*#__PURE__*/function (_Component) {
  _inherits(NotFound, _Component);

  var _super = _createSuper(NotFound);

  function NotFound(props) {
    var _this;

    _classCallCheck(this, NotFound);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function () {
      var query = _this.state.query;
      var urlToRedirect = "https://atencionalcliente.movistar.es/?q=".concat(query);
      window.location.href = urlToRedirect;
    });

    _defineProperty(_assertThisInitialized(_this), "setQuery", function (query) {
      _this.setState({
        query: query
      });
    });

    _this.state = {
      query: ''
    };
    return _this;
  }

  _createClass(NotFound, [{
    key: "render",
    value: function render() {
      var icon2Input = {
        id: 'Buscar',
        kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.MEDIUM,
        color: 'black'
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "NotFoundContent",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents["default"], {
          text: "404",
          level: _gerenciatdUnifiedcomponents.HEADING_LEVEL.H2,
          kind: _gerenciatdUnifiedcomponents.KIND_TEXT.HEADING,
          align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
          color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
          size: _gerenciatdUnifiedcomponents.SIZE.DISPLAY2,
          fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.THIN
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents["default"], {
          text: "Lo sentimos, esta p\xE1gina no existe",
          kind: _gerenciatdUnifiedcomponents.KIND_TEXT.PARAGRAPH,
          align: _gerenciatdUnifiedcomponents.ALIGN.CENTER,
          color: _gerenciatdUnifiedcomponents.COLOR.WHITE,
          size: _gerenciatdUnifiedcomponents.SIZE.TITLE3,
          fontType: _gerenciatdUnifiedcomponents.FONT_TYPE.LIGHT
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2["default"], {
          method: "get",
          onSubmit: this.handleSearch,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3["default"], {
            id: "notFound-input",
            actionInput: this.handleSearch,
            svgIconProps: icon2Input,
            theme: _gerenciatdUnifiedcomponents3.THEME.ROUNDED,
            onChange: this.setQuery,
            placeHolder: "\xBFQu\xE9 est\xE1s buscando?",
            taggingInfo: {},
            cleanButton: true
          })
        })]
      });
    }
  }]);

  return NotFound;
}(_react.Component);

var _default = NotFound;
exports["default"] = _default;

//# sourceMappingURL=index.js.map